import { useMemo } from 'react';

import { useUserContext } from '@context/UserContext';
import { AB_TEST_SERVICE_INFO_MODAL } from '@utils/constants';

export const useAbTestServiceInfoModal = () => {
  const {
    state: { abTests },
  } = useUserContext();

  return useMemo(() => {
    return {
      showServiceInfoModal: abTests.get(AB_TEST_SERVICE_INFO_MODAL) === 2,
    };
  }, [abTests]);
};
